export default __webpack_public_path__ + "static/images/google-play-badge-18c82042541c7a927136120e72392d16.png";